<template>
    <div class="basic-section" :class="{section7: pageIndex == 7}">
        <div class="retirement-group" v-if="pageIndex == 6">
            <ul class="retirement-list">
                <li
                    v-for="(item, index) in dataSource.retirementList"
                    :key="index"
                    :class="[{checked: item.selected},'option', 'option'+index]"
                    @click="singleSelect(item, 'retirementList', 'retirement')"
                >
                    <h4>{{item.name | capitalize}}</h4>
                </li>
            </ul>
            <div class="expenses-monthly">
                <h4>{{$t('UJ.section6.subtitle')}}</h4>
                <div class="number-input">
                    <span
                        class="expenses-currency"
                    >{{defaultSetting.currency_code}} {{defaultSetting.currency_symbol}}</span>
                    <numeric-input
                        v-if="_collectModels.retirement_annual_expenses != undefined"
                        type="number"
                        v-model="_collectModels.retirement_annual_expenses"
                        @change="checkSingleField"
                    ></numeric-input>
                    <span class="expenses-per-month">{{$t('UJ.section6.perMonth')}}</span>
                </div>
            </div>
        </div>

        <div class="card-list" v-if="pageIndex == 7">
            <ul class="card-group">
                <li
                    v-for="(item, index) in dataSource.pipeList"
                    :key="index"
                    :class="['uj-pipe'+ (index+1), 'card-item', {selected: item.selected}]"
                    @click="singleSelect(item, 'pipeList', 'portfolio_breakdown')"
                >
                    <h4>{{item.title}}</h4>
                    <p>{{item.desc}}</p>
                    <ul class="card-points">
                        <li class="percent1">{{item.percent1}}</li>
                        <li class="percent2">{{item.percent2}}</li>
                        <li class="percent3">{{item.percent3}}</li>
                        <li class="percent4">{{item.percent4}}</li>
                    </ul>
                </li>
            </ul>
            <div class="card-detail" :class=" 'uj-pipe'+(_collectModels.portfolio_breakdown+1)">
                <h4>{{collectList.title}}</h4>
                <p>{{collectList.desc}}</p>
                <ul class="card-points">
                    <li class="percent1">{{collectList.percent1}}</li>
                    <li class="percent2">{{collectList.percent2}}</li>
                    <li class="percent3">{{collectList.percent3}}</li>
                    <li class="percent4">{{collectList.percent4}}</li>
                </ul>
            </div>
        </div>

        <div class="slider-card" v-if="pageIndex == 8">
            <p class="title">
                {{$t('UJ.section8.subtitle')}}
                <span
                    class="hidden-xs-only"
                >{{defaultSetting.currency_code}} {{defaultSetting.currency_symbol}}</span>
                <numeric-input
                    v-if="_collectModels.real_estate_target != undefined"
                    type="number"
                    v-model="_collectModels.real_estate_target"
                ></numeric-input>
            </p>
            <div class="adjust-slider">
                <h4>{{defaultSetting.currency_code}} {{defaultSetting.currency_symbol}} {{_collectModels.real_estate_target | NumFormat}}</h4>
                <div class="block">
                    <h4 class="real-estate">{{$t('UJ.section8.realEstate')}}</h4>
                    <el-slider
                        :min="defaultSetting.real_estate_target_min_amount"
                        :max="defaultSetting.real_estate_target_max_amount"
                        :step="1000"
                        v-model="_collectModels.real_estate_target"
                        :show-tooltip="false"
                        @change="changeInput"
                    ></el-slider>
                    <div class="range-price">
                        <span class="min-price">{{defaultSetting.real_estate_target_min_label}}</span>
                        <span class="max-price">{{defaultSetting.real_estate_target_max_label}}</span>
                    </div>
                </div>
            </div>
            <p class="little-hint hidden-sm-and-up">{{$t('UJ.section8.adjustSlider')}}</p>
            <p class="little-hint hidden-xs-only">{{$t('UJ.section8.adjustSliderOrInput')}}</p>
        </div>

        <div class="check-list" v-if="pageIndex == 9">
            <ul>
                <li
                    v-for="(item, index) in dataSource.worthList"
                    :key="index"
                    :class="{selected: item.selected}"
                    @click="singleSelect(item, 'worthList', 'worthList')"
                >{{item.label}}</li>
            </ul>
        </div>

        <div class="invitation" v-if="pageIndex == 10">
            <span>{{$t('UJ.section10.invitation_code')}}</span>
            <input
                type="text"
                v-model.lazy="invitation_code"
                :placeholder="$t('UJ.section10.enter_code')"
            >
        </div>
    </div>
</template>

<style lang="scss" scoped>
.invitation {
    padding: 15px 27px;
    span {
        display: block;
        width: 100%;
        font-family: GothamBook;

        font-size: 14px;
        color: #333333;
    }
    input {
        display: block;
        width: 100%;
        border: 0;
        font-family: GothamMedium;
        font-size: 14px;
        font-weight: 500;
        text-align: left;
        color: #333333;
    }
}
@media (min-width: 768px) {
    .invitation {
        height: 80px;
        line-height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span,
        input {
            font-size: 16px;
        }
        input {
            text-align: right;
        }
    }
}
</style>

<script>
import numericInput from "@/components/common/numeric-input.vue";
export default {
    name: "UJSection2",
    props: {
        pageIndex: {},
        defaultSetting: {},
        requestParams: {},
        collectModels: {}
    },
    data() {
        const $t = this.$t.bind(this);
        return {
            dataSource: {
                retirementList: [
                    {
                        name: $t("UJ.section6.option1"),
                        value: "MODEST",
                        selected: false
                    },
                    {
                        name: $t("UJ.section6.option2"),
                        value: "COMFORTABLE",
                        selected: true
                    },
                    {
                        name: $t("UJ.section6.option3"),
                        value: "PREMIUM",
                        selected: false
                    }
                ],
                pipeList: [
                    {
                        title: $t("UJ.section7.option0.title"),
                        desc: $t("UJ.section7.option0.desc"),
                        selected: true,
                        portfolio_breakdown: 0,
                        percent1: $t("UJ.section7.realEstate", { num: "20%" }),
                        percent2: $t("UJ.section7.bonds", { num: "5%" }),
                        percent3: $t("UJ.section7.stocks", { num: "70%" }),
                        percent4: $t("UJ.section7.cash", { num: "5%" })
                    },
                    {
                        title: $t("UJ.section7.option1.title"),
                        desc: $t("UJ.section7.option1.desc"),
                        selected: false,
                        portfolio_breakdown: 1,
                        percent1: $t("UJ.section7.realEstate", { num: "50%" }),
                        percent2: $t("UJ.section7.bonds", { num: "30%" }),
                        percent3: $t("UJ.section7.stocks", { num: "10%" }),
                        percent4: $t("UJ.section7.cash", { num: "10%" })
                    },
                    {
                        title: $t("UJ.section7.option2.title"),
                        desc: $t("UJ.section7.option2.desc"),
                        selected: false,
                        portfolio_breakdown: 2,
                        percent1: $t("UJ.section7.realEstate", { num: "25%" }),
                        percent2: $t("UJ.section7.bonds", { num: "25%" }),
                        percent3: $t("UJ.section7.stocks", { num: "25%" }),
                        percent4: $t("UJ.section7.cash", { num: "25%" })
                    },
                    {
                        title: $t("UJ.section7.option3.title"),
                        desc: $t("UJ.section7.option3.desc"),
                        selected: false,
                        portfolio_breakdown: 3,
                        percent1: $t("UJ.section7.realEstate", { num: "0%" }),
                        percent2: $t("UJ.section7.bonds", { num: "0%" }),
                        percent3: $t("UJ.section7.stocks", { num: "50%" }),
                        percent4: $t("UJ.section7.cash", { num: "50%" })
                    }
                ],
                worthList: []
            },

            _collectModels: {},

            globalParams: {},
            collectList: {
                title: "",
                desc: "",
                percent1: "",
                percent2: "",
                percent3: "",
                percent4: ""
            },

            invitation_code: ""
        };
    },

    beforeMount() {
        this._collectModels = this.collectModels;
        this._collectModels.real_estate_target =
            this.defaultSetting.real_estate_target_max_amount / 2;
        this.changeExpenses();

        this._collectModels.retirement_annual_expenses = this.defaultSetting[
            `${this._collectModels.retirement_annual_expenses_type}_amount`
        ];
    },

    mounted() {
        this.collectList = this.dataSource.pipeList[0];
    },

    methods: {
        changeInput() {
            this.$emit("paginationNext", {
                next: true,
                _collectModels: this._collectModels
            });
        },

        singleSelect(item, selectlist, target) {
            this["dataSource"][selectlist].forEach(it => (it.selected = false));
            item.selected = true;

            if (target == "retirement") {
                this._collectModels.retirement_annual_expenses_type =
                    item.value;
            } else if (target == "portfolio_breakdown") {
                this._collectModels.portfolio_breakdown =
                    item.portfolio_breakdown;

                this.collectList = item;
            } else if (target == "worthList") {
                this._collectModels.net_worth_range = item.id;
            }
            this.changeExpenses();

            this.$emit("paginationNext", {
                next: true,
                _collectModels: this._collectModels
            });
        },

        changeExpenses() {
            this._collectModels.retirement_annual_expenses_type = this._collectModels.retirement_annual_expenses_type.toUpperCase();
            if (
                this._collectModels.retirement_annual_expenses_type == "MODEST"
            ) {
                this._collectModels.retirement_annual_expenses = this.defaultSetting.modest_amount;
            } else if (
                this._collectModels.retirement_annual_expenses_type ==
                "COMFORTABLE"
            ) {
                this._collectModels.retirement_annual_expenses = this.defaultSetting.comfortable_amount;
            } else if (
                this._collectModels.retirement_annual_expenses_type == "PREMIUM"
            ) {
                this._collectModels.retirement_annual_expenses = this.defaultSetting.premium_amount;
            }
        },

        checkSingleField() {
            if (
                this._collectModels.retirement_annual_expenses != "" ||
                this._collectModels.retirement_annual_expenses >= 100
            ) {
                this.$emit("paginationNext", {
                    next: true
                });
            } else {
                return;
            }
        },

        getWorthList() {
            this.dataSource.worthList = JSON.parse(
                JSON.stringify(this.defaultSetting.ranges)
            );

            this.dataSource.worthList.forEach(it => {
                this.$set(it, "selected", false);
            });
        }
    },

    filters: {
        capitalize: function(value) {
            if (!value) return "";
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        NumFormat: function(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    watch: {
        defaultSetting: {
            handler(newVal, oldVal) {
                this.defaultSetting = newVal;

                this._collectModels.retirement_annual_expenses =
                    newVal[
                        `${this._collectModels.retirement_annual_expenses_type.toLowerCase()}_amount`
                    ];
                this._collectModels.real_estate_target =
                    this.defaultSetting.real_estate_target_max_amount / 2;

                this.getWorthList();
            },
            deep: true
        },

        invitation_code: {
            handler(newVal, oldVal) {
                this.$emit("code", this.invitation_code);
            },
            deep: true
        }
    },

    components: {
        numericInput
    }
};
</script>



// WEBPACK FOOTER //
// src/components/userJourney/UJStep2.vue